import { render, staticRenderFns } from "./CoursePointsDialog.vue?vue&type=template&id=2000b23e&scoped=true&"
import script from "./CoursePointsDialog.vue?vue&type=script&lang=js&"
export * from "./CoursePointsDialog.vue?vue&type=script&lang=js&"
import style0 from "./CoursePointsDialog.vue?vue&type=style&index=0&id=2000b23e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2000b23e",
  null
  
)

export default component.exports